var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { pictureCropIcon, pictureRestoreIcon, pictureRotateIcon, pictureRemoveIcon, pictureFloatLeftIcon, pictureFloatRightIcon, } from './icon.js';
import { parseAngleStringToRad } from './utils.js';
let ExEditorPictureToolbarElement = class ExEditorPictureToolbarElement extends LitElement {
    constructor() {
        super(...arguments);
        this.crop = false;
        this.allowFloat = false;
        this.rotateStep = '90deg';
        this.float = '';
        this.t = (token, fallback) => fallback !== null && fallback !== void 0 ? fallback : token;
    }
    render() {
        const { t } = this;
        const rad = parseAngleStringToRad(this.rotateStep);
        const deg = Math.round((rad / Math.PI) * 180);
        return html `
      <exeditor-toolbar-button
        class="item"
        label="${t('裁剪')}"
        ?active=${this.crop}
        @click=${this.toggleCrop}
      >
        <span class="icon" .innerHTML=${pictureCropIcon}></span>
      </exeditor-toolbar-button>

      <exeditor-toolbar-button
        class="item"
        label="${t('顺时针旋转')}${deg}°"
        @click=${() => this.handleRotate(rad)}
      >
        <span class="icon hmirror" .innerHTML=${pictureRotateIcon}></span>
      </exeditor-toolbar-button>

      <exeditor-toolbar-button
        class="item"
        label="${t('逆时针旋转')}${deg}°"
        @click=${() => this.handleRotate(-rad)}
      >
        <span class="icon" .innerHTML=${pictureRotateIcon}></span>
      </exeditor-toolbar-button>

      ${this.allowFloat
            ? html `
            <exeditor-toolbar-button
              class="item"
              label="${t('向左浮动')}"
              ?active=${this.float === 'left'}
              @click=${() => this.handleFloat('left')}
            >
              <span class="icon" .innerHTML=${pictureFloatLeftIcon}></span>
            </exeditor-toolbar-button>

            <exeditor-toolbar-button
              class="item"
              label="${t('向右浮动')}"
              ?active=${this.float === 'right'}
              @click=${() => this.handleFloat('right')}
            >
              <span class="icon" .innerHTML=${pictureFloatRightIcon}></span>
            </exeditor-toolbar-button>
          `
            : ''}

      <exeditor-toolbar-button
        class="item"
        label="${t('恢复原图')}"
        @click=${this.handleRestore}
      >
        <span class="icon" .innerHTML=${pictureRestoreIcon}></span>
      </exeditor-toolbar-button>

      <exeditor-toolbar-button
        class="item"
        label="${t('删除')}"
        @click=${this.handleRemove}
      >
        <span class="icon" .innerHTML=${pictureRemoveIcon}></span>
      </exeditor-toolbar-button>
    `;
    }
    toggleCrop() {
        this.triggerToolClick('crop');
    }
    handleRotate(rad) {
        this.triggerToolClick('rotate', rad);
    }
    handleRestore() {
        this.triggerToolClick('restore');
    }
    handleRemove() {
        this.triggerToolClick('remove');
    }
    handleFloat(direction) {
        this.triggerToolClick('float', this.float === direction ? '' : direction);
    }
    triggerToolClick(type, value) {
        const event = new CustomEvent('toolclick', {
            composed: true,
            detail: { type, value },
        });
        this.dispatchEvent(event);
    }
};
ExEditorPictureToolbarElement.styles = [
    css `
      :host {
        display: flex;
        background-color: #fcfcfc;
        color: #555;
        box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014,
          0 9px 28px 8px #0000000d;
      }
      .item {
        margin: 0 2px;
        font-size: 14px;
      }
      .icon {
        font-size: 18px;
      }
      .icon > svg {
        display: block;
        width: 1em;
        height: 1em;
      }
      .icon.hmirror > svg {
        transform: scaleX(-1);
      }
    `,
];
__decorate([
    property({
        attribute: true,
        type: Boolean,
    })
], ExEditorPictureToolbarElement.prototype, "crop", void 0);
__decorate([
    property({
        attribute: true,
        type: Boolean,
    })
], ExEditorPictureToolbarElement.prototype, "allowFloat", void 0);
__decorate([
    property({
        attribute: 'rotate-step',
    })
], ExEditorPictureToolbarElement.prototype, "rotateStep", void 0);
__decorate([
    property({
        attribute: true,
    })
], ExEditorPictureToolbarElement.prototype, "float", void 0);
__decorate([
    property()
], ExEditorPictureToolbarElement.prototype, "t", void 0);
ExEditorPictureToolbarElement = __decorate([
    customElement('exeditor-picture-toolbar')
], ExEditorPictureToolbarElement);
export { ExEditorPictureToolbarElement };
//# sourceMappingURL=picture-toolbar.js.map